import { MobileBookingSpikedTireSeasonBanner } from '@components/BookingFlow/Common/MobileBookingSpikedTireSeasonBanner';
import { TimeWindowModal } from '@components/BookingFlow/Mobile/TimeWindows/TimeWindowModal';
import { CustomerTimePickerNotices } from '@components/Common/CustomerTimePickerNotices';
import { Trans } from '@lingui/react/macro';
import { DeliveryWindowOutputRecord } from '@navio/nsdk';
import { BookingAddress } from 'noddi-types';
import { NoddiButton } from 'noddi-ui-web';
import { getSalesItemCarsPayload, mapToDeliveryWindow } from 'noddi-util';
import {
  BookingTimeWindowPicker,
  tracking,
  useAuthContext,
  useBookingActions,
  useBookingSelectedSalesItemsCars,
  useBookingTimeWindow
} from 'noddi-web';
import { useState } from 'react';
import { useCurrentBrand } from '../../../../stores/BrandStore/brandStore';
import { getCommonTranslations } from '../../../../utils/commonTranslations';

type Props = {
  selectedAddress: BookingAddress;
};

export const TimeWindowPicker = ({ selectedAddress }: Props) => {
  const { isSuperUser } = useAuthContext();
  const { currentBrand } = useCurrentBrand();
  const [showExtraInfoModal, setShowExtraInfoModal] = useState(false);

  const selectedSalesItemsCars = useBookingSelectedSalesItemsCars();
  const selectedBookingTimeWindow = useBookingTimeWindow();
  const { setSelectedTimeWindow } = useBookingActions();

  const onSelect = (timeWindow: DeliveryWindowOutputRecord) => {
    setSelectedTimeWindow(timeWindow);
  };

  const selectedDeliveryWindow = mapToDeliveryWindow(selectedBookingTimeWindow);

  return (
    <>
      <TimeWindowModal open={showExtraInfoModal} onClose={() => setShowExtraInfoModal(false)} />
      <MobileBookingSpikedTireSeasonBanner />
      <CustomerTimePickerNotices
        surface='mobile'
        addressId={selectedAddress.id}
        selectedSalesItemIds={selectedSalesItemsCars.map((item) => item.salesItemId)}
      />
      <BookingTimeWindowPicker
        address={selectedAddress}
        cars={getSalesItemCarsPayload(selectedSalesItemsCars)}
        brandDomain={currentBrand}
        surface='page'
        onUnavailableSelect={(timeWindow) => {
          if (!isSuperUser) {
            return;
          }
          onSelect(timeWindow);
        }}
        selectedDeliveryWindow={selectedDeliveryWindow}
        onAvailableSelect={(timeWindow) => {
          if (
            selectedDeliveryWindow?.endsAt !== timeWindow.endsAt ||
            selectedDeliveryWindow?.startsAt !== timeWindow.startsAt
          ) {
            tracking.track('timeWindowChanged');
          }
          onSelect(timeWindow);
        }}
        translations={getCommonTranslations().timePicker}
        customButton={
          <NoddiButton
            size='small'
            className='h-9 md:h-8'
            startIcon='Info'
            data-track='clickedReadMoreAboutDeliveryTimePicker'
            onClick={() => setShowExtraInfoModal(true)}
            variant='outline'
          >
            <Trans>About delivery</Trans>
          </NoddiButton>
        }
      />
    </>
  );
};
